import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { IntlProvider } from 'react-intl';
import { queryClient } from '@/shared/api/query-client';
import { LocaleProvider, useLocale } from '@/shared/i18n/locale-context';
import { messages, defaultLocale } from '@/shared/i18n/messages';

function IntlProviderWrapper({ children }: { children: React.ReactNode }) {
	const { locale } = useLocale();

	return (
		<IntlProvider messages={messages[locale]} locale={locale} defaultLocale={defaultLocale}>
			{children}
		</IntlProvider>
	);
}

export function AppProviders({ children }: { children: React.ReactNode }) {
	return (
		<QueryClientProvider client={queryClient}>
			<LocaleProvider>
				<IntlProviderWrapper>
					{children}
					<ReactQueryDevtools initialIsOpen={false} />
				</IntlProviderWrapper>
			</LocaleProvider>
		</QueryClientProvider>
	);
}
